import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const QuickContactWidget = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const contactOptions = [
    {
      type: 'phone',
      label: 'Dinslaken anrufen',
      value: '02064 777722',
      href: 'tel:02064 777722',
      icon: 'Phone',
      color: 'bg-primary'
    },
    {
      type: 'whatsapp',
      label: 'WhatsApp Dinslaken',
      value: '+49 1636923382',
      href: 'https://wa.me/491636923382?text=Hallo,%20ich%20möchte%20einen%20Termin%20für%20Autopflege%20vereinbaren.',
      icon: 'MessageCircle',
      color: 'bg-success'
    }
  ];

  const handleContactClick = (option) => {
    // Analytics tracking could be added here
    window.open(option?.href, option?.type === 'whatsapp' ? '_blank' : '_self');
    setIsExpanded(false);
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerHeight = 80;
      const elementPosition = element?.getBoundingClientRect()?.top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsExpanded(false);
  };

  return (
    <div className="hidden lg:block fixed bottom-6 right-6 z-[900] lg:bottom-8 lg:right-8">
      {/* Expanded Options */}
      {isExpanded && (
        <div className="absolute bottom-16 right-0 mb-4 space-y-3 animate-fade-in">
          {/* Contact Form Option */}
          <div className="bg-white rounded-lg shadow-card border p-3 min-w-[200px]">
            <button
              onClick={scrollToContact}
              className="w-full flex items-center space-x-3 p-2 rounded-lg hover:bg-muted transition-colors"
            >
              <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center">
                <Icon name="Mail" size={16} color="white" />
              </div>
              <div className="text-left">
                <p className="text-sm font-medium text-foreground">Kontakt</p>
                <p className="text-xs text-muted-foreground">Nachricht senden</p>
              </div>
            </button>
          </div>

          {/* Contact Options */}
          {contactOptions?.map((option, index) => (
            <div key={index} className="bg-white rounded-lg shadow-card border p-3 min-w-[200px]">
              <button
                onClick={() => handleContactClick(option)}
                className="w-full flex items-center space-x-3 p-2 rounded-lg hover:bg-muted transition-colors"
              >
                <div className={`w-8 h-8 ${option?.color} rounded-lg flex items-center justify-center`}>
                  <Icon name={option?.icon} size={16} color="white" />
                </div>
                <div className="text-left">
                  <p className="text-sm font-medium text-foreground">{option?.label}</p>
                  <p className="text-xs text-muted-foreground">{option?.value}</p>
                </div>
              </button>
            </div>
          ))}
        </div>
      )}
      {/* Main FAB */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className={`w-14 h-14 bg-accent hover:bg-accent/90 rounded-full shadow-card flex items-center justify-center transition-all duration-300 ${
          isExpanded ? 'rotate-45' : 'rotate-0'
        }`}
        aria-label={isExpanded ? 'Kontaktoptionen schließen' : 'Kontaktoptionen öffnen'}
      >
        <Icon name={isExpanded ? "X" : "Phone"} size={24} color="white" />
      </button>
      {/* Mobile Bottom Center Alternative */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 p-4 bg-white/95 backdrop-blur-nav border-t shadow-nav">
        <div className="flex space-x-2">
          <Button
            variant="outline"
            className="flex-1"
            onClick={() => handleContactClick(contactOptions?.[0])}
            iconName="Phone"
            iconPosition="left"
          >
            Anrufen
          </Button>
          <Button
            variant="outline"
            className="flex-1"
            onClick={() => handleContactClick(contactOptions?.[2])}
            iconName="MessageCircle"
            iconPosition="left"
          >
            WhatsApp
          </Button>
          <Button
            variant="default"
            className="flex-1 bg-accent hover:bg-accent/90"
            onClick={scrollToContact}
            iconName="Mail"
            iconPosition="left"
          >
            Kontakt
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickContactWidget;